import CollegeActionTypes from "./college.types";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import { permIndices } from "../../Permissions";

const INITIAL_STATE = {
  user: {},
  permissions: {},
  institution: {},
  campuses: [],
  personnel: [],
  classes: []
}

const collegeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CollegeActionTypes.UPDATE_TO_ROOT:
      // console.log("updating:", action.payload)
      let newState = {
        ...state,
        user: action.payload.user,
        institution: action.payload.institution,
        campuses: action.payload.campuses,
        personnel: action.payload.personnel,
        classes: action.payload.classes,
      }
      newState.user.role = action.payload.role;

      let permissions = {};
      const permissionKeys = Object.keys(permIndices)

      if (newState.user.permissions) {
        // convert permission to boolean value
        permissionKeys.forEach(key => {
          permissions[key] = !!(newState.user.permissions & (1 << permIndices[key]))
        })
      }
      else if (newState.user.role === "customer") {
        permissionKeys.forEach(key => {
          permissions[key] = true;
        })
      }
      newState.permissions = permissions;

      return newState;

    case CollegeActionTypes.UPDATE_COLLEGE_DETAILS:
      return {
        ...state,
        institution: updateCollegeDetails(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_INST_LOGO:
      return {
        ...state,
        institution: updateInstLogo(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_INST_TAGLINE:
      return {
        ...state,
        institution: updateInstTagline(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_INST_WEBSITE:
      return {
        ...state,
        institution: updateInstWebsite(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_INST_CAN_DELIVER:
      return {
        ...state,
        institution: updateInstCanDeliverV2(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_INST_ROOMS_PROGRAMS:
      return {
        ...state,
        institution: updateInstRoomsProgramsV2(state.institution, action.payload)
      }

    case CollegeActionTypes.UPDATE_USER_DETAILS:
      return {
        ...state,
        user: updateUserDetails(state.user, action.payload)
      }

    case CollegeActionTypes.UPDATE_PERSONNEL_DETAILS:
      return {
        ...state,
        user: updatePersonnelDetails(state.user, action.payload)
      }

    case CollegeActionTypes.ADD_CAMPUS:
      return {
        ...state,
        campuses: addCampus(state.campuses, action.payload)
      }

    case CollegeActionTypes.ADD_CAMPUS_TO_PERSONNEL:
      return {
        ...state,
        campuses: addCampus(state.campuses, action.payload),
        user: pushCampus(state.user, action.payload),
      }

    case CollegeActionTypes.EDIT_CAMPUS:
      return {
        ...state,
        campuses: updateCampus(state.campuses, action.payload)
      }

    case CollegeActionTypes.DELETE_CAMPUS:
      return {
        ...state,
        campuses: deleteCampus(state.campuses, action.payload)
      }

    case CollegeActionTypes.ADD_PERSONNEL:
    case CollegeActionTypes.CREATE_PERSONNEL:
      return {
        ...state,
        personnel: createPersonnel(state.personnel, action.payload)
      }

    case CollegeActionTypes.UPDATE_PERSONNEL:
      return {
        ...state,
        personnel: updatePersonnel(state.personnel, action.payload)
      }

    case CollegeActionTypes.DELETE_PERSONNEL:
      return {
        ...state,
        personnel: deletePersonnel(state.personnel, action.payload)
      }

    case CollegeActionTypes.ADD_CLASS:
      return {
        ...state,
        classes: addClass(state.classes, action.payload)
      }

    case CollegeActionTypes.EDIT_CLASS:
      return {
        ...state,
        classes: updateClass(state.classes, action.payload.class_id, action.payload.newData)
      }

    case CollegeActionTypes.DELETE_CLASS:
      return {
        ...state,
        classes: deleteClass(state.classes, action.payload)
      }

    case CollegeActionTypes.ADD_REMOVE_FAVOURITE_TEACHER:
      return {
        ...state,
        institution: addRemoveFavouriteTeacher(state.institution, action.payload)
      }

    case CollegeActionTypes.BLOCK_UNBLOCK_TEACHER:
      return {
        ...state,
        institution: blockUnblockTeacher(state.institution, action.payload.teacher_id, action.payload.is_blocked)
      }

    case CollegeActionTypes.UPDATE_CUSTOMER_INFO:
      return {
        ...state,
        user: action.payload
      }

    case CollegeActionTypes.UPDATE_INSTITUTION_INFO:
      return {
        ...state,
        institution: action.payload
      }

    default:
      return state;
  }
}

export default collegeReducer;

const updateCollegeDetails = (institution, details) => {
  // const newCollege = Object.assign({}, institution, details);
  // const msg = "Institution details updated successfully";

  // axios.put(`${PORT}/placeholder`, {
  //   institution: newCollege,
  // })
  //   .then((res) => {
  //     notify.show(msg)
  //   })
  //   .catch((err) => {
  //     console.log(err)
  //   })

  // return newCollege;
}

 const updateInstLogo = (inst_id, suffix) => {
   console.log("https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/institutions/" + suffix.inst_id + "/logo" + suffix.suffix);
  const newCollege = Object.assign({}, inst_id);
  newCollege.logo =  "https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/institutions/" + suffix.inst_id + "/logo" + suffix.suffix;
  //newCollege.logo = logo.logo
  API.updateInstLogo(inst_id,suffix).then(res=>{
    
  }).catch(err=>{
    console.log(err)
    notify.show("Error updating Logo")
  })
  return newCollege;
}

const updateInstTagline = (inst, tagline) => {
  const newInst = Object.assign({}, inst);
  newInst.tagline = tagline;

  API.updateInstTagline(inst._id, tagline)
    .then(res => {
      notify.show("Tagline updated")
    })
    .catch(err => {
      console.log(err)
      notify.show("Error updating tagline")
    })

  return newInst;
}

const updateInstWebsite = (inst, url) => {
  const newInst = Object.assign({}, inst);
  newInst.website_url = url;

  API.updateInstWebsite(inst._id, url)
    .then(res => {
      notify.show("Website URL updated")
    })
    .catch(err => {
      console.log(err)
      notify.show("Error updating website URL")
    })

  return newInst;
}

const updateInstCanDeliver = (inst, can_deliver) => {
  const newInst = Object.assign({}, inst);
  newInst.can_deliver = can_deliver

  API.updateInstCanDeliver(inst._id, can_deliver)
    .then(res => {
      notify.show("Courses updated")
    })
    .catch(err => {
      console.log(err)
      notify.show("Error updating courses")
    })

  return newInst;
}

const updateInstCanDeliverV2 = (inst, payload) => {
  const newInst = {...inst};
  newInst.selected_can_delivers = payload.selected_can_delivers

  API.updateCanDeliverOfInstitution(payload)
    .then(res => {
      notify.show("Courses updated")
      window.location.reload()
    })
    .catch(err => {
      console.log(err)
      notify.show("Error updating courses")
    })

  return newInst;
}

const updateInstRoomsProgramsV2 = (inst, payload) => {
  const newInst = {...inst};
  newInst.selected_rooms_programs = payload.selected_rooms_programs

  API.updateRoomsProgramsOfInstitution(payload)
    .then(res => {
      notify.show("Rooms & Programs updated")
      window.location.reload()
    })
    .catch(err => {
      console.log(err)
      notify.show("Error updating Rooms & Programs")
    })

  return newInst;
}

const updateUserDetails = (user, details) => {
  let newUser = Object.assign({}, user, details);
  delete user.role;
  const msg = "User details updated successfully";

  API.updateCustomer({
    user: newUser,
  })
    .then((res) => {
      notify.show(msg)

      // Email notification
      var send = false
      if (!user.tpen) {
        send = true
      } else if (user.tpen.charAt(7) == '0') {
        send = true
      }

      // console.log(user, send)
    })
    .catch((err) => {
      console.log(err)
    })

  return newUser;
}

// for adding profile photo for personnel - lieh
const updatePersonnelDetails = (user, details) => {
  let newUser = Object.assign({}, user, details);
  delete user.role;
  const msg = "User details updated successfully";

  API.updatePersonnelDetails({
    user: newUser,
  })
    .then((res) => {
      notify.show(msg)

      // Email notification
      var send = false
      if (!user.tpen) {
        send = true
      } else if (user.tpen.charAt(7) == '0') {
        send = true
      }

      // console.log(user, send)
    })
    .catch((err) => {
      console.log(err)
    })

  return newUser;
}

const addCampus = (campuses, payload) => {
  campuses.unshift(payload)
  return campuses;
}

const pushCampus = (user, payload) => {
  user.campuses.push(payload._id)
  return user;
}

const updateCampus = (campuses, payload) => {
  // console.log('update campus', campuses, payload)
  const msg = "Campus updated successfully";
  let newCampuses = [...campuses];
  newCampuses = newCampuses.map(campus => {
    if (campus._id === payload._id) {
      return payload;
    }
    else return campus;
  })

  // API.updateCampus(payload)
  //   .then((res) => {
  //     notify.show(msg);
  //   }).catch(err => {
  //     console.log(err.response)
  //   })

  return newCampuses;
}

const deleteCampus = (campuses, payload) => {
  // console.log(payload)
  let newCampuses = campuses.filter((ele) => { return ele._id !== payload.campus_id })
  // console.log(newCampuses)
  const msg = "Campus deleted successfully";
  API.deleteCampus({
    _id: payload.campus_id,
    customer_id: payload.customer_id ? payload.customer_id : null,
    personnel_id: payload.personnel_id ? payload.personnel_id : null,
    fullcontrol: payload.fullcontrol,
  }).then((res) => {
    notify.show(msg);
  }).catch(err => {
    console.log(err)
  })
  return newCampuses;
}

const createPersonnel = (personnel, payload) => {
  personnel.unshift(payload)

  return personnel
}

const deletePersonnel = (personnel, payload) => {
  // console.log('delete payload', personnel, payload)
  var index = -1
  for (var i = 0; i < personnel.length; i++) {
    if (personnel[i]._id == payload._id) {
      index = i
      break
    }
  }

  if (index != -1) {
    // console.log('delete this', index, personnel[index])
    personnel.splice(index, 1)
  }

  return personnel
}

const updatePersonnel = (personnel, payload) => {
  // console.log('update p', personnel, payload)
  const msg = "Personnel updated successfully";

  for (var i = 0; i < personnel.length; i++) {
    if (personnel[i]._id == payload._id) {
      personnel[i] = payload
      notify.show(msg)
      break
    }
  }

  return personnel
}

const addClass = (classes, newClass) => {
  let newClasses = [...classes];
  newClasses.unshift(newClass);

  return newClasses;
}

const updateClass = (classes, class_id, newData) => {
  let newClasses = classes.map(classObj => {
    if (classObj._id === class_id) {
      return {
        _id: class_id,
        ...newData
      }
    }
    else return classObj;
  })
  const msg = "Class updated successfully";

  const payload = {
    _id: class_id,
    newData: newData,
  }

  if (payload.newData?.is_duplicate) {
    payload.is_duplicate = true
    delete payload.newData.is_duplicate
  }

  API.updateClass(payload)
  .then((res) => {
    notify.show(msg)
  }).catch(err => {
    console.log(err)
  })

  return newClasses;
}

const deleteClass = (classes, classObj) => {
  let newClasses = [...classes];
  newClasses = newClasses.filter(cls => { return cls._id !== classObj._id });

  const msg = "Class deleted successfully";
  API.deleteClass(classObj._id)
    .then((res) => {
      notify.show(msg);
    }).catch(err => {
      console.log(err)
    })

  return newClasses;
}

const addRemoveFavouriteTeacher = (inst, teacher_id) => {
  let fav_teacher_list = [...inst.fav_teacher_list]
  let msg_type = ""

  // switch (type) {
  //   case "add":
  //     if (!fav_teacher_list.includes(teacher_id)) {
  //       fav_teacher_list.push(teacher_id)
  //       msg_type = "added to"
  //     }
  //     break;
  //   case "remove":
  //     fav_teacher_list.filter(teacher => teacher !== teacher_id)
  //     msg_type = "removed from"
  //     break;
  //   default:
  //     break;
  // }

  if (fav_teacher_list.includes(teacher_id)) {
    fav_teacher_list = fav_teacher_list.filter(id => id !== teacher_id)
    msg_type = "removed from"
  } else {
    fav_teacher_list.push(teacher_id)
    msg_type = "added to"
  }

  if (msg_type) {
    API.addRemoveFavouriteTeacher(inst._id, fav_teacher_list)
      .then(res => {
        notify.show("Teacher " + msg_type + " favourites")
      })
      .catch(err => {
        notify.show("Error updating favourites")
        console.log(err)
      })
  }

  const newInst = { ...inst }
  newInst.fav_teacher_list = fav_teacher_list

  return newInst;
}

const blockUnblockTeacher = (inst, teacher_id, is_blocked) => {
  let block_list = inst.block_list ? [...inst.block_list] : []
  let msg_type = ""

  if (is_blocked) {
    block_list = block_list.filter(id => id !== teacher_id)
    msg_type = "removed from"
  } else {
    block_list.push(teacher_id)
    msg_type = "added to"
  }

  // update API
  if (msg_type) {
    API.blockUnblockTeacher(inst._id, block_list)
      .then(res => {
        notify.show("Teacher " + msg_type + " block list")
      })
      .catch(err => {
        notify.show("Error updating block list")
        console.log(err)
      })
  }

  const newInst = { ...inst }
  newInst.block_list = block_list

  return newInst;
}